<template>
  <div class=wrapper>
    <div id="player" class="player">
    </div>
  </div>
</template>

<script>
import { db, brightcove } from '@/config'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import brightcovePlayerLoader from '@brightcove/player-loader';

export default {
  name: 'Video',
  data () {
    return {
      fromTimestamp: false,
      player: null,
      session: null,
      sessionRef: null,
      modalData: null,
      setupInit: null,
      pid: null,
      activePid: null,
      playingVideo: false,
      first_play_event: 'first_play'
    }
  },
  computed: {
    ...mapGetters(['program'])
  },
  async created () {
    this.fromTimestamp = this.$route.query.timestamp
    await this.getProgramBySlug(this.$route.params.slug)
    this.modalData = this.program
    this.init()

    window.addEventListener("beforeunload", (e) => {
      this.beforeExit()
      return true
    });
  },
  activated () {
    this.first_play_event = 'first_play'
  },
  methods: {
    ...mapActions(['getProgramBySlug', 'userData', 'log_video_views']),
    ...mapMutations(['setVideoBack']),
    setup () {

      console.log(this.modalData)

      const source = {
        type: 'application/dash+xml',
        src: this.modalData.video.dash,
        keySystems: {
          'com.widevine.alpha': 'https://widevine-dash.ezdrm.com/proxy?pX=1512CB',
          'com.microsoft.playready': 'https://playready.ezdrm.com/cency/preauth.aspx?pX=2FAC2F'
        }
      };

      console.log(process.env);
      console.log(brightcove[process.env.VUE_APP_ID === 'microcanales-cne-df069' ? 'hun' : 'cz'].accountId);

      brightcovePlayerLoader({
        refNode: document.querySelector('#player'),
        accountId: brightcove[process.env.VUE_APP_ID === 'microcanales-cne-df069' ? 'hun' : 'cz'].accountId,
        playerId: 'default',
        videoId: this.modalData.video.brightcoveId || null,
        options: {
          autoplay: true
        } 
      }).then((success) => {
        clearInterval(this.pid)

        this.player= success.ref

        console.log('success', success)

        this.modalData.video.brightcoveId || this.player.src(source)

        this.player.on('loadedmetadata',() => {
          var session = {
            program_slug: this.modalData.slug,
            user_id: this.$store.getters.user.uid,
            date: new Date().getTime(),
            duration: 0,
            device_id: this.$store.state.deviceId,
            ip: this.$store.state.ip,
            prefered_language_audio: 'es',
            prefered_language_subtitulos: 'es'
          }
          this.session = session
          var ref = db.collection('log_video_views').doc()
          this.sessionRef = ref
          ref.set(this.session)
        })

        this.player.on('playing', () => {
          console.log('Video', 'player is playing', this.$store.getters.user)
          if (this.fromTimestamp) {
            this.fromTimestamp = false
            console.log('user', this.$store.getters.user, this.modalData)
            db.collection('users_videos_last_times')
              .doc(this.$store.getters.user.uid)
              .collection('videos')
              .doc(this.modalData.id || this.modalData.slug)
              .get().then((doc) => {
                var data = doc.data()
                console.log('Video', '{timestamp}', data)
                if (data && data.timestamp) {
                  this.player.currentTime(data.timestamp)
                }
                this.log_video_views({
                  event: this.first_play_event,
                  program_slug: this.modalData.slug,
                  duration: data.timestamp || 0
                })
                this.first_play_event = 'play'
              })
          } else {
            console.log('Video', Math.round(this.player.currentTime()))
            this.log_video_views({
              event: this.first_play_event,
              program_slug: this.modalData.slug,
              duration: Math.round(this.player.currentTime())
            })
            this.first_play_event = 'play'
          }
        })

        this.player.on('pause', () => {

          console.log('Video', '...pause...', ev)
          this.log_video_views({
            event: 'pause',
            program_slug: this.modalData.slug,
            duration: Math.round(this.player.currrentTime())
          })
        })

      })
        .catch(function(error) {
          console.log('error', error);
        })

    },
    async init () {
      this.startActiveUser()
      this.setVideoBack(true)
      clearInterval(this.pid)
      this.pid = setInterval(() => {
        if (this.modalData && this.modalData.slug === this.$route.params.slug) {
          this.setup()
        }
      }, 1000)
      console.log('Video', 'PID', this.pid)
    },
    startActiveUser() {
      clearInterval(this.activePid)
      this.doActiveTick()
      this.activePid = setInterval(() => {
        this.doActiveTick()
      }, 300000)
    },
    doActiveTick() {
      console.log('Video', '**************(TICK ACTIVE USER)**************')
      db.collection('active_users')
      .doc(this.$store.getters.user.uid)
      .set({
        lastPlay: new Date().getTime()
      })
    },
    removeActiveUser() {
      clearInterval(this.activePid)
      db.collection('active_users')
      .doc(this.$store.getters.user.uid)
      .delete()
    },
    async beforeExit() {
      this.setVideoBack(false)
      console.log('beforeExit:Video', '<beforeRouteLeave>')
      console.log('beforeExit:Video', 'player destroy', this. player)
      clearInterval(this.pid)
      this.removeActiveUser()
      this.setupInit = null

      if (this.player) {

        const allTime = this.player.duration()
        var current = this.player.currentTime()

        if (this.session) {
          const duration = (new Date().getTime()) - this.session.date
          console.log('Video', 'duration:', duration)
          console.log('Video', '[this.sessionRef]' ,this.sessionRef)
          await this.sessionRef.update({ duration: duration })
        } else {
          await this.sessionRef.update({ duration: Math.round(this.player.currentTime()) })
        }

        try {
          await db.doc(`users_videos_last_times/${this.$store.getters.user.uid}`).set({
            updated_at: new Date()
          })
          await db.doc(`users_videos_last_times/${this.$store.getters.user.uid}/videos/${this.modalData.id}`).set({
            id: this.modalData.id,
            slug: this.modalData.slug,
            timestamp: current,
            duration: allTime,
            progress: 100 * (current || 0) / (allTime || 1),
            user_id: this.$store.getters.user.uid
          }, { merge: true })
        } catch(error) {
          console.error(error)
        }

      }
      try {
      this.log_video_views({
        event: 'exit',
        program_slug: this.modalData.slug,
        duration: Math.round(this.player ? this.player.currentTime() : 0)
      })
      } catch(error) {console.error(error)}
      this.modalData = null
      brightcovePlayerLoader.reset();
    }
  },
  watch: {
    program () {
      console.log('Video', '--WATCH--', 'program')
      this.modalData = this.program
    },
    async '$route' (to, from, other) {
      console.log('Video', '--WATCH--', 'route')
      console.log('Video', 'NAME-ID', to.name, to.params)
      if (to.name === 'Video' && to.params.id) {
        this.fromTimestamp = this.$route.query.timestamp
        await this.getProgram(this.$route.params.id)
        this.modalData = this.program
        this.init()
      } else if (to.name === 'Video' && to.params.slug) {
        this.fromTimestamp = this.$route.query.timestamp
        await this.getProgramBySlug(this.$route.params.slug)
        this.modalData = this.program
        this.init()
      }
    },
  },
  beforeRouteLeave (to, from, next) {
    this.beforeExit()
    console.log('Video', '[NEXT]')
    next()
  }
}
</script>
<style scoped>
.wrapper {
  background: black;
  width: 100%;
  height: calc(100vh - 64px);
}
.player {
  width: 100vw;
  height: calc(100vh - 64px);
  margin: auto;
  box-shadow: 0px 0px 56px 0px rgba(0, 0, 0, 0.75);
}
.video-js {
  width: 100vw;
  height: calc(100vh - 64px);
  margin: auto;
  box-shadow: 0px 0px 56px 0px rgba(0, 0, 0, 0.75);
}
</style>
<style>
.video-js {
  width: 100vw;
  height: calc(100vh - 64px);
  margin: auto;
  box-shadow: 0px 0px 56px 0px rgba(0, 0, 0, 0.75);
}

.vjs-dock-text {
  display: none;
}

.vjs-dock-shelf {
  display: none;
}
</style>
